import Repository from '@/repositories/repository'
import { convertToEnglishSlug } from '@/utils/cmsRoutesMap/cmsRoutesMap'

const blogRepository = {
  async getBlogBySlug(queryParams: any = {}, slug: string | null) {
    const params = {
      ...queryParams
    }
    slug = convertToEnglishSlug(slug as string)
    return await Repository(slug as string, 'post_by_slug', params)
  },
  async getLatestBlogs(queryParams: any = {}, category: string) {
    const params = {
      page_size: '10',
      page: '1',
      ...queryParams
    }

    return await Repository(category, 'post', params)
  }
}

export default blogRepository
